module.exports = __webpack_public_path__ + "img/hohlsaum_lichtblau_ral5012.06eb4100.jpg";